import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "my-2"
}
const _hoisted_2 = {
  key: 1,
  class: "my-2"
}

import PhaseInfoCell from '@ui-kit/components/PhaseInfoCell.vue'
import { PATIENT_UNIT as UNIT, type MemberUnitType } from '@/scripts/configs/patient-units'
import type { MemberDrawerProtocolInfo } from '@/components/drawers/MemberDrawer/types/member-drawer.types'


export default /*@__PURE__*/_defineComponent({
  __name: 'MemberDrawerContentPatientPrescription',
  props: {
    unit: {},
    protocol: {},
    bloomProgramName: {},
    noPodSessionsAllowed: { type: Boolean }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  const _component_sword_tag = _resolveComponent("sword-tag")!

  return (_openBlock(), _createElementBlock("div", null, [
    (__props.unit === _unref(UNIT).BLOOM)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.$t(__props.bloomProgramName || 'SIDEBAR.NO_PRESCRIPTION')) + " ", 1),
          (__props.noPodSessionsAllowed)
            ? (_openBlock(), _createBlock(_component_sword_tag, {
                key: 0,
                class: "ml-2",
                size: "sm",
                color: "blue"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('NO_POD_SESSION.AVAILABLE')), 1)
                ], undefined, true),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (__props.protocol)
            ? (_openBlock(), _createBlock(PhaseInfoCell, {
                key: 0,
                "current-phase": __props.protocol.currentPhase,
                "total-phases": __props.protocol.totalPhases,
                "start-date": __props.protocol.startDate,
                "end-date": __props.protocol.endDate,
                name: __props.protocol.name,
                outdated: __props.protocol.outdated
              }, null, 8, ["current-phase", "total-phases", "start-date", "end-date", "name", "outdated"]))
            : (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.$t("SIDEBAR.DEFAULT_PRESCRIPTION")), 1))
        ], 64))
  ]))
}
}

})